// components/TitleUpdater/TitleUpdater.tsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useResolvedTitleParts } from './hooks/useResolvedTitleParts';
import { useTitle } from './useTitle'; 

/**
 * Component that automatically updates the browser tab title.
 * It uses a specialized hook to resolve nested entity logic and loading states.
 */
export const TitleUpdater = () => {
  const { pathname, search } = useLocation();
  const { updateMultiple } = useTitle();
  const { 
    fullTitle, 
    entityName, 
    pageName, 
    measurementDate, 
    isLoading 
  } = useResolvedTitleParts(pathname, search);

  useEffect(() => {
    // Only update global state context if we aren't in a loading flicker
    if (!isLoading) {
      updateMultiple({
        pageTypeName: entityName,
        pageName,
        measurementDate,
      });
    }

    // Always update document title (falls back to "Scalar" via the hook if loading)
    document.title = fullTitle;
  }, [fullTitle, entityName, pageName, measurementDate, isLoading, updateMultiple]);

  return null;
};
